<div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
    <h4 class="matDialogTitle" mat-dialog-title [textContent]="title + ' Configuration'"></h4>
    <span class="material-icons mb-2" mat-dialog-close>close</span>
</div>
<mat-dialog-content class="mat-typography">
    <app-integrationfields [subTenants]="subTenants" [masterTables]="masterTables" [editRecord]="record" (onRecordSubmit)="submitConfiguration($event)" (cancelRecord)="closeModal()"></app-integrationfields>
</mat-dialog-content>
